import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddEditHolidayNotificationsWorkflowModal = React.lazy(
  () => import("./add-edit-holiday-notifications-workflow.modal"),
);

const AddEditHolidayNotificationsWorkflow: iModalProps<
  typeof AddEditHolidayNotificationsWorkflowModal,
  { workflowId?: string }
> = {
  name: "add-edit-holiday-notifications-workflow",
  component: GenerateModalWithSuspense(
    AddEditHolidayNotificationsWorkflowModal,
  ),
};

export default AddEditHolidayNotificationsWorkflow;
